var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.02 31.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#249281;}.cls-2{fill:#323338;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4764",
    "data-name": "Group 4764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7693",
    "data-name": "Path 7693",
    className: "cls-1",
    d: "M13.65,8.43V18.48l5-8.71a10,10,0,0,0-5-1.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7694",
    "data-name": "Path 7694",
    className: "cls-2",
    d: "M13.64,5.11A13.37,13.37,0,1,0,27,18.48,13.36,13.36,0,0,0,13.64,5.11m0,25.75A12.38,12.38,0,1,1,26,18.48,12.38,12.38,0,0,1,13.64,30.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7695",
    "data-name": "Path 7695",
    className: "cls-2",
    d: "M15.83,0H11.47a.66.66,0,0,0,0,1.32H13v2.6a5.83,5.83,0,0,1,1.32,0V1.32h1.51a.66.66,0,0,0,0-1.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7696",
    "data-name": "Path 7696",
    className: "cls-2",
    d: "M4,5.92l-.79-1A15.82,15.82,0,0,0,0,8l1.05.79q.44-.56.9-1.08l1,1a6.74,6.74,0,0,1,.91-.94l-1-1c.34-.31.7-.61,1.07-.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7697",
    "data-name": "Path 7697",
    className: "cls-2",
    d: "M18.28,10.45h0a.41.41,0,0,0,.58-.16h0l.49-.83a.44.44,0,0,0-.16-.58.42.42,0,0,0-.58.16h0l-.48.83a.42.42,0,0,0,.15.58h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7698",
    "data-name": "Path 7698",
    className: "cls-2",
    d: "M8.1,28.08h0a.43.43,0,0,0,.59-.15h0l.48-.83A.44.44,0,0,0,9,26.51a.42.42,0,0,0-.58.16L8,27.5a.42.42,0,0,0,.15.58h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7699",
    "data-name": "Path 7699",
    className: "cls-2",
    d: "M4.2,13.52,5,14a.43.43,0,0,0,.59-.16.44.44,0,0,0-.16-.58l-.83-.48a.41.41,0,0,0-.58.16.42.42,0,0,0,.15.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7700",
    "data-name": "Path 7700",
    className: "cls-2",
    d: "M21.83,23.7l.84.48a.42.42,0,0,0,.58-.16.44.44,0,0,0-.16-.58h0L22.26,23a.42.42,0,0,0-.58.16.42.42,0,0,0,.15.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7701",
    "data-name": "Path 7701",
    className: "cls-2",
    d: "M18.13,27.09l.48.83a.44.44,0,0,0,.58.16.45.45,0,0,0,.16-.59l-.48-.83a.43.43,0,0,0-.59-.15.42.42,0,0,0-.15.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7702",
    "data-name": "Path 7702",
    className: "cls-2",
    d: "M8,9.46l.48.83a.42.42,0,0,0,.58.16.44.44,0,0,0,.16-.58L8.69,9A.43.43,0,1,0,8,9.46H8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7703",
    "data-name": "Path 7703",
    className: "cls-2",
    d: "M4,24H4a.43.43,0,0,0,.59.16h0l.83-.48a.44.44,0,0,0,.16-.58A.43.43,0,0,0,5,23H5l-.83.48A.44.44,0,0,0,4,24h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7704",
    "data-name": "Path 7704",
    className: "cls-2",
    d: "M23.25,12.93h0a.42.42,0,0,0-.58-.15h0l-.84.48a.42.42,0,0,0-.15.58.43.43,0,0,0,.58.16h0l.83-.48a.44.44,0,0,0,.16-.58h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7705",
    "data-name": "Path 7705",
    className: "cls-2",
    d: "M13.65,29.57h0a.42.42,0,0,0,.42-.43v-1a.42.42,0,0,0-.42-.43h0a.43.43,0,0,0-.43.43v1a.43.43,0,0,0,.43.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7706",
    "data-name": "Path 7706",
    className: "cls-2",
    d: "M13.65,9.21h0a.42.42,0,0,0,.42-.43v-1a.42.42,0,0,0-.42-.43h0a.43.43,0,0,0-.43.43v1a.43.43,0,0,0,.43.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7707",
    "data-name": "Path 7707",
    className: "cls-2",
    d: "M4,18.05H3a.43.43,0,0,0-.43.43h0a.43.43,0,0,0,.43.43H4a.42.42,0,0,0,.42-.43h0A.42.42,0,0,0,4,18.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7708",
    "data-name": "Path 7708",
    className: "cls-2",
    d: "M22.92,18.48h0a.43.43,0,0,0,.43.43h1a.42.42,0,0,0,.42-.43h0a.42.42,0,0,0-.42-.43h-1a.43.43,0,0,0-.43.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7709",
    "data-name": "Path 7709",
    className: "cls-2",
    d: "M18,11A.06.06,0,0,0,18,11a0,0,0,0,0-.07,0h0c-.44.57-4.57,6.35-5,7.05l0,0a.81.81,0,0,0,.3,1.11.8.8,0,0,0,1.11-.29l0,0C14.73,18.3,17.72,11.7,18,11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIn);
export default __webpack_public_path__ + "static/media/clockIn.3d35598bb9f37c8e373c11b06144fc67.svg";
export { ForwardRef as ReactComponent };